import { gql } from "@apollo/client";
import { AsyncActionStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import { useResettableMutation } from "../useResettableMutation";
import { UpdateAdminRole, UpdateAdminRoleVariables } from "./__generated__/UpdateAdminRole";

const UPDATE_ADMIN_ROLE = gql`
  mutation UpdateAdminRole(
    $organizationId: String!
    $roleId: String!
    $displayName: String
    $permissionNames: [String!]
  ) {
    updateAdminRole(
      input: {
        organizationId: $organizationId
        roleId: $roleId
        displayName: $displayName
        permissionNames: $permissionNames
      }
    ) {
      adminRoleId
    }
  }
`;

export function useUpdateAdminRole() {
  const [mutate, { loading, data, error, reset, called }] = useResettableMutation<
    UpdateAdminRole,
    UpdateAdminRoleVariables
  >(UPDATE_ADMIN_ROLE, {
    errorPolicy: "all",
  });
  return {
    mutate,
    data,
    status: {
      loading,
      reset,
      called,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncActionStatus,
  };
}
